import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

// Card for Artists, Staff and Presenters

const CardPersonnel = ({ artist, item }) => {
	const placeholderImage =
		"/wp-content/themes/masc/dist/images/svg/placeholder.svg";

	// conditional for artist (links to page) vs staff (opens modal)
	const ConditionalLink = artist ? `a` : "div"; // eslint-disable-line

	// artist
	const artistDisciplines = item.disciplines
		? item.disciplines.join(", ")
		: null;

	// staff + presenters
	const [openModal, setOpenModal] = useState(false);

	const openModalHandler = () => {
		if (!artist) {
			setOpenModal(true);
			document.body.style.overflow = "hidden";
		}
	};

	const closeModalHandler = () => {
		setOpenModal(false);
		document.body.style.overflow = "unset";
	};

	const modalRef = useRef(null);

	// click on page body to close modal, ref passed to modal__wrap container
	const closeModalOnBodyClick = (ref) => {
		useEffect(() => {
			const handleClickOutside = (event) => {
				// check if ref exists and if the click is outside of it
				if (ref.current && !ref.current.contains(event.target)) {
					setOpenModal(false);
					document.body.style.overflow = "unset";
				}
			};

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	};

	closeModalOnBodyClick(modalRef);

	return (
		<>
			<li
				className="card-personnel"
				aria-label={item.name}
				onClick={openModalHandler}
				data-aos-duration="750"
				data-aos="fade"
				data-aos-delay="500"
			>
				<ConditionalLink {...(artist ? { href: item.url } : {})}>
					<div className="card-personnel__image">
						<img
							src={item.image ? item.image : placeholderImage}
							alt={item.image_alt ? item.image_alt : `photo of ${item.name}`}
						/>
					</div>
					<div className="card-personnel__info">
						<h3>{item.name}</h3>
						{artistDisciplines && <p>{artistDisciplines}</p>}
						{item.title && <p>{item.title}</p>}
					</div>
				</ConditionalLink>
			</li>

			{!artist && (
				<div
					className={
						openModal
							? "card-personnel__modal--open"
							: "card-personnel__modal--closed"
					}
				>
					<div className="modal__pop-up">
						<div className="container-body">
							<div className="modal__wrap" ref={modalRef}>
								<div className="modal__close" onClick={closeModalHandler}>
									<img
										alt="close-modal"
										src="/wp-content/themes/masc/dist/images/svg/icons/icon-close.svg"
										height="28px"
										width="28px"
									/>
								</div>
								<div className="modal__details">
									{item.image && (
										<div className="card-personnel__image">
											<img
												src={item.image}
												alt={
													item.image_alt
														? item.image_alt
														: `photo of ${item.name}`
												}
											/>
										</div>
									)}
									<div className="details-wrap">
										<h4>{item.name}</h4>
										<p className="title">{item.title}</p>
										{item.website && (
											<a
												href={item.website}
												className="email"
												target="_blank"
												rel="noopener noreferrer"
											>
												Website
											</a>
										)}
										{item.email && (
											<a href={`mailto:${item.email}`} target={"_blank"} className="email">
												{item.email}
											</a>
										)}
									</div>
								</div>

								{item.bio && (
									<div className="modal__bio">
										<p>{item.bio}</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default CardPersonnel;

CardPersonnel.propTypes = {
	artist: PropTypes.string,
	item: PropTypes.instanceOf(Object).isRequired,
};

CardPersonnel.defaultProps = {
	artist: "",
};
